import {dedupingMixin} from '@polymer/polymer/lib/utils/mixin';
import {parseInputColor} from '../../javascripts/modules/colors.js';

/**
 * @polymer
 * @mixinFunction
 **/
export const CanvasSelectionBehavior = dedupingMixin((superClass) => class extends superClass {
  static get properties() {
    return {
      _canvasContext: {type: Object},
      _creatingOverlayCanvas: {type: Boolean},
      _mouseIsDown: {type: Boolean},
      _mouseWasDragged: {type: Boolean},
      _overlayCanvas: {type: Object},
      _startPosition: {type: Object},
      canvasSelectionContainer: {type: Object, observer: 'canvasSelectionContainerChanged'},
      canvasSelectionElement: {type: Object},
      canvasSelectionButtons: {type: Object, value: () => [0]},
      canvasSelectionEnabled: {type: Boolean},
    }
  }

  connectedCallback() {
    super.connectedCallback();

    this._boundSelectionMouseDown = this.handleMouseDown.bind(this);
    this._boundSelectionMouseMove = this.handleMouseMove.bind(this);
    this._boundSelectionMouseUp = this.handleMouseUp.bind(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this._canvasContext = null;
    this.canvasSelectionContainer = null;
    this.canvasSelectionElement = null;
  }

  canvasSelectionContainerChanged(newValue, oldValue) {
    if (newValue) {
      newValue.addEventListener('mousedown', this._boundSelectionMouseDown);
      newValue.addEventListener('mousemove', this._boundSelectionMouseMove);
      newValue.addEventListener('mouseup', this._boundSelectionMouseUp);
    }
    if (oldValue) {
      oldValue.removeEventListener('mousedown', this._boundSelectionMouseDown);
      oldValue.removeEventListener('mousemove', this._boundSelectionMouseMove);
      oldValue.removeEventListener('mouseup', this._boundSelectionMouseUp);
    }
  }

  getMousePosition(event, canvas) {
    if (!canvas && !this._overlayCanvas) {
      return;
    }
    const bounds = (canvas || this._overlayCanvas).getBoundingClientRect();
    return {x: event.clientX - bounds.left, y: event.clientY - bounds.top};
  }

  handleMouseDown(event) {
    if (!this.canvasSelectionButtons.includes(event.button) || !this.canvasSelectionEnabled || !this.canvasSelectionElement) {
      return;
    }
    this._mouseIsDown = true;
    this._startPosition = this.getMousePosition(event, this.canvasSelectionElement);
    this._overlayCanvas?.remove();
  }

  handleMouseMove(event) {
    if (!this._mouseIsDown || this._creatingOverlayCanvas) {
      return;
    }

    if (!this._overlayCanvas) {
      this._creatingOverlayCanvas = true;
      this._overlayCanvas = this.canvasSelectionElement.cloneNode(true);
      this._overlayCanvas.style.cursor = 'crosshair';
      this.canvasSelectionElement.insertAdjacentElement('afterend', this._overlayCanvas);
      this._canvasContext = this._overlayCanvas.getContext('2d');
      this._creatingOverlayCanvas = false;
    }

    this._mouseWasDragged = true;

    const position = this.getMousePosition(event);
    this._canvasContext.clearRect(0, 0, this._overlayCanvas.width, this._overlayCanvas.height);
    this._canvasContext.beginPath();
    this._canvasContext.rect(this._startPosition.x, this._startPosition.y, position.x - this._startPosition.x, position.y - this._startPosition.y);
    this._canvasContext.strokeStyle = parseInputColor('500');
    this._canvasContext.lineWidth = 1;
    this._canvasContext.fillStyle = parseInputColor('500', .1);
    this._canvasContext.stroke();
    this._canvasContext.fill();
  }

  handleMouseUp(event) {
    if (!this._mouseIsDown) {
      return;
    }

    if (this._mouseWasDragged) {
      const position = this.getMousePosition(event);
      this.handleCanvasSelectionFinished(event, {
        type: 'rectangle',
        x: this._startPosition.x,
        y: this._startPosition.y,
        width: position.x - this._startPosition.x,
        height: position.y - this._startPosition.y,
      });
    }

    this._mouseIsDown = false;
    this._mouseWasDragged = false;
    this._startPosition = null;
    this._canvasContext = null;
    this._overlayCanvas?.remove();
    this._overlayCanvas = null;
  }

  /**
   * Must be implemented on the parent component.
   */
  handleCanvasSelectionFinished() {
    console.warn('%cCanvas Selection Behavior:', 'background: #fc0; color: #000', 'Method `handleCanvasSelectionFinished` not defined.');
  }
});